import { render } from "./EventBS.vue?vue&type=template&id=b5af44bc"
import script from "./EventBS.vue?vue&type=script&lang=js"
export * from "./EventBS.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__